import * as React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormControl,
  Grid,
  TextField,
} from '@material-ui/core';

const validateRegistrationValues = values => {
  const errors: { [name: string]: string } = {};
  const requiredFields = ['fullName', 'email', 'password', 'confirmPassword'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address';
  }
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }
  if (!values.terms) {
    errors.terms = 'You must read and agree to the terms and conditions';
  }
  return errors;
};

const renderTextField = ({ input, label, meta, type, imgsrc, disabled }) => (
  <Grid container spacing={8} alignItems="flex-end">
    <Grid item xs={1} md={1} sm={1} lg={1} xl={1}>
      <img src={imgsrc} />
    </Grid>
    <Grid item xs={11} md={11} sm={11} lg={11} xl={11}>
      <TextField
        label={label}
        type={type}
        {...input}
        disabled={disabled}
        fullWidth
        helperText={meta.touched && meta.error}
        error={meta.touched && !!meta.error}
      />
    </Grid>
  </Grid>
);

const renderCheckboxField = ({ input, meta, disabled }) => (
  <Grid container spacing={8} alignItems="flex-end">
    <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
      <FormControl error={!!meta.error}>
        <FormControlLabel
          control={<Checkbox color="primary" {...input} value={input.name} />}
          label={
            <span style={{ fontSize: '16px' }}>
              I agree to the{' '}
              <a
                href="https://www.donaco.co/terms-and-conditions"
                target="_blank"
              >
                terms and conditions
              </a>
            </span>}
        />
        {meta.touched && meta.error && (
          <FormHelperText>{meta.error}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  </Grid>
);

const CharityRegisterFormComponent: React.SFC<any> = props => {
  const { submitting, handleSubmit } = props;

  return (
    <div className="register-form">
      <img
        className="register-form-logo-img"
        src="../../../../assets/images/logo.png"
      />
      <h1 className="register-form-heading">
        Sign up for Donaco It's easy to get started.
      </h1>
      <div className="main-div">
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 30 }}>
            <Field
              name="fullName"
              type="text"
              component={renderTextField}
              label="Full Name"
              imgsrc="../../../../assets/images/user-icon.png"
              disabled={submitting}
            />
          </div>
          <div style={{ marginBottom: 30 }}>
            <Field
              name="email"
              type="email"
              component={renderTextField}
              label="Email Address"
              imgsrc="../../../../assets/images/email-icon.png"
              disabled={submitting}
            />
          </div>
          <div style={{ marginBottom: 30 }}>
            <Field
              name="password"
              type="password"
              component={renderTextField}
              label="Password"
              imgsrc="../../../../assets/images/password-icon.png"
              disabled={submitting}
            />
          </div>
          <div style={{ marginBottom: 40 }}>
            <Field
              name="confirmPassword"
              type="password"
              component={renderTextField}
              label="Confirm Password"
              imgsrc="../../../../assets/images/password-icon.png"
              disabled={submitting}
            />
          </div>
          <div
            className="form-group terms-cond-checkbox"
            style={{ marginBottom: '40px' }}
          >
            <Field
              name="terms"
              component={renderCheckboxField}
              disabled={submitting}
            />
          </div>
          <div>
            <Button
              disabled={submitting}
              type="submit"
              variant="outlined"
              className="btn btn-primary"
              fullWidth
            >
              Register
            </Button>
          </div>
        </form>
        <div className="row register-form-bottom-box">
          <Link to="/">Cancel</Link>
        </div>
      </div>
    </div>
  );
};

const CharityRegisterForm: any = reduxForm({
  form: 'charityRegister', // a unique identifier for this form
  validate: validateRegistrationValues,
})(CharityRegisterFormComponent);

export { CharityRegisterForm, validateRegistrationValues };
